

// function showHello(divName: string, name: string) {
//   const elt = document.getElementById(divName);
// }


import { eqArr, eqNew, pid } from './config';

interface EqData {
  id: string,
  name: string,
  num: number,
  tip?: number
}


// init
(function () {

  function eqPic(item: EqData): string {
    return `<span class="eq-pic fn-eq" data-id="${item.id}" data-tip="${item.tip || 0}" data-num="${item.num}" style="background-image:url('https://web-resource.17m3.com/cdn/m3-eq/${item.id}.png')"></span>`;
  }

  // body dom
  function viewList(arr = []): string {

    let dom: Array<string> = [];

    arr.forEach((items) => {

      let str = '';

      items.list.forEach((item) => {
        str += `<li class="eq-item">${eqPic(item)}</li>`;
      });

      dom.push(`<div class="bd-item">
          <p class="bd-title is-${items.title}">${items.title}</p>
          <ul class="bd-eq">${str}</ul>
        </div>`);

    });

    return dom.join('');
  };

  // 底部dom
  function viewNew(arr = []): string {

    let dom: Array<string> = [];

    arr.forEach(item => {
      dom.push(`<li class="eq-item">${eqPic(item)}</li>`);
    });

    return `<ul class="new-eq">${dom.join('')}</ul>`;
  };


  const tip = {

    format(str: string = ''): string {
      return str.replace(/\|r\|n\|cff99d3ff\s\|r\d{0,2}\.{0,1}\|pUI.*?\|e\|(\w{9})/gi, '|r|n|$1')
        .replace(/\|r\|pUI(.*?)\|e\|\S*/g, '').replace(/\|n/g, '<br/>')
        .replace(/\|cff(\w{6})/gi, '<span style="color:#$1">')
        .replace(/\|r/g, '</span>');
    },

    getStr(id: string = '', cb = (desc) => { }) {
      $.ajax({
        url: 'https://tool.m3guo.com/api/web/m3goods/eq-item',
        type: 'get',
        data: { id },
        dataType: 'json',
        timeout: 5000,
        xhrFields: {
          withCredentials: true
        },
        success(res) {
          if (res.code === 1) {
            cb(res.data[0].desc);;
            return;
          }
          console.log(id, '无数据');
        }
      });
    },

    show(id: string = '', pic: string = '') {
      let localKey = localStorage.getItem(`${pid}-${id}`);

      // console.log(id, pic);
      if (pic === '1') {
        // 图片
        $('#fn-tip__pic').show().html(`<img src="https://web-resource.17m3.com/cdn/m3-eq-tip/${id}.jpg"/>`);
      } else {
        if (localKey) {
          // 内存读取
          $('#fn-tip__desc').show().html(this.format(localKey));
        } else {
          this.getStr(id, desc => {
            // 设置缓存
            localStorage.setItem(`${pid}-${id}`, desc);
            $('#fn-tip__desc').show().html(this.format(desc));
          });
        }
      }

      $('#fn-tip').addClass('fn-show');
    },

    hide() {
      $('#fn-tip__desc,#fn-tip__pic').html('').hide();
      $('#fn-tip').removeClass('fn-show');
    },

    pos(event) {
      let mouse_x = event.clientX;
      let mouse_y = event.clientY;
      let window_x = $(window).innerWidth();
      let window_y = $(window).innerHeight();
      let dom_w = $('#fn-tip').width();
      let dom_h = $('#fn-tip').height();
      let dom_top = mouse_y + 10;
      let dom_left = mouse_x + 10;

      // console.log(mouse_x, mouse_y, window_x, window_y, dom_w, dom_h);

      if (mouse_x + dom_w > window_x) {
        dom_left = mouse_x - dom_w - 10;
      }
      if (mouse_y + dom_h > window_y) {
        dom_top = mouse_y - dom_h - 10;
      }

      return {
        top: dom_top + 'px',
        left: dom_left + 'px'
      };
    }
  };

  const appScreenWidth: number = 750;

  let app = {

    init() {
      $('#fn-bd').html(viewList(eqArr));
      $('#fn-ft').append(viewNew(eqNew));
      $('body').append('<div id="fn-tip"><div id="fn-tip__desc"></div><div id="fn-tip__pic"></div></div>');


      this.even();
    },

    even() {

      // 谷歌 edge 360
      window.addEventListener('mousewheel', this.wheelWatch) ||
        window.addEventListener('DOMMouseScroll', this.wheelWatch);

      $('body')
        .on('mouseenter', '.fn-eq', function (e) {
          if (window.innerWidth <= appScreenWidth) {
            return;
          }
          let id = $(this).attr('data-id');
          let pic = $(this).attr('data-tip');
          tip.show(id, pic);
          $('#fn-tip').css(tip.pos(e));
        })
        .on('mouseleave', '.fn-eq', function () {
          if (window.innerWidth <= appScreenWidth) {
            return;
          }
          tip.hide();
        })
        .on('click', '.fn-eq', function () {
          if (window.innerWidth > appScreenWidth) {
            return;
          }
          let id = $(this).attr('data-id');
          let pic = $(this).attr('data-tip');
          tip.show(id, pic);
        })
        .on('click', '#fn-tip', function () {
          tip.hide();
        });

      $('#fn-down').on('click', function () {
        $('body,html').animate({
          'scrollTop': 690
        });
      });

      $('#fn-back').on('click', function () {
        $('body,html').animate({
          'scrollTop': 0
        });
      });
    },

    wheelWatch() {
      tip.hide();
    }
  };

  app.init();
})();
